import { create } from 'zustand';

// نقاط البيع لا تقبل دفع نقدي مباشر — الافتراضي تعليق على الكارت/الجلسة.
const initialPayment = () => ({
  method: 'on_session',
  paidAmount: 0,
  cashboxId: null
});

const initialState = (dept = 'cafeteria') => ({
  dept,
  cart: [],
  invoiceDiscount: 0,
  link: null, // { sessionId, cardUid, childId, childName, photoUrl, cardBalance, linkedBy }
  payment: initialPayment()
});

export const usePosState = create((set, get) => ({
  ...initialState('cafeteria'),

  setDept: (dept) => set((s) => ({
    ...initialState(dept),
    payment: { ...initialPayment(), cashboxId: s.payment.cashboxId }
  })),

  addProduct: (p) => set((s) => {
    const id = String(p._id || p.id);
    const idx = s.cart.findIndex((it) => String(it.productId) === id);
    if (idx >= 0) {
      const next = [...s.cart];
      next[idx] = { ...next[idx], qty: next[idx].qty + 1 };
      return { cart: next };
    }
    const item = {
      productId: id,
      name: p.name,
      sku: p.sku,
      emoji: p.emoji || '',
      imageUrl: p.imageUrl || '',
      unitPrice: Number(p.salePrice) || 0,
      qty: 1,
      discount: 0,
      stock: Number(p.currentStock) || 0
    };
    return { cart: [...s.cart, item] };
  }),

  setQty: (productId, qty) => set((s) => ({
    cart: s.cart.map((it) =>
      String(it.productId) === String(productId)
        ? { ...it, qty: Math.max(1, Math.floor(Number(qty) || 1)) }
        : it
    )
  })),

  setLineDiscount: (productId, value) => set((s) => ({
    cart: s.cart.map((it) =>
      String(it.productId) === String(productId)
        ? { ...it, discount: Math.max(0, Math.floor(Number(value) || 0)) }
        : it
    )
  })),

  removeLine: (productId) => set((s) => ({
    cart: s.cart.filter((it) => String(it.productId) !== String(productId))
  })),

  clearCart: () => set({ cart: [], invoiceDiscount: 0 }),

  setInvoiceDiscount: (v) => set({ invoiceDiscount: Math.max(0, Math.floor(Number(v) || 0)) }),

  setLink: (link) => set((s) => ({
    link,
    payment: { ...s.payment, method: 'on_session' }
  })),

  unlink: () => set((s) => ({
    link: null,
    payment: { ...s.payment, method: 'on_session' }
  })),

  setPayment: (patch) => set((s) => ({ payment: { ...s.payment, ...patch } })),

  resetAfterSale: ({ keepLink = false } = {}) => set((s) => ({
    cart: [],
    invoiceDiscount: 0,
    link: keepLink ? s.link : null,
    payment: { ...initialPayment(), cashboxId: s.payment.cashboxId }
  })),

  // selectors
  subtotal: () => {
    const cart = get().cart;
    return cart.reduce((sum, it) => {
      const lineGross = it.qty * it.unitPrice;
      const lineDisc = Math.min(lineGross, it.discount || 0);
      return sum + Math.max(0, lineGross - lineDisc);
    }, 0);
  },
  grandTotal: () => Math.max(0, get().subtotal() - get().invoiceDiscount)
}));
